import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import {
  getUserAvailableApps,
  updateUserAppSettings,
} from '../services/userLabourAppService.js'
import type { UserLabourApp } from '@/types/user-labour-app'

export const useUserLabourAppStore = defineStore('userLabourApp', () => {
  const apps = ref<UserLabourApp[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  function getAppById(id: number): UserLabourApp | undefined {
    return apps.value.find((app) => app.id === id)
  }

  const userPinnedApps = computed(() =>
    apps.value.filter((item) => item?.user_settings?.[0]?.pinned) ?? []
  )

  async function updateUserHasPinnedAppStatus(labourAppId: number, value: boolean) {
    const app = getAppById(labourAppId)
    if (app) {
      app.user_settings = [{ pinned: value }]
    }

    await updateUserAppSettings({
      id: labourAppId,
      pivot: { pinned: value },
    })
  }

  function userHasPinnedApp(labourAppId: number): boolean {
    return !!userPinnedApps.value.find((app) => app.id === labourAppId)
  }

  async function fetchApps() {
    isLoading.value = true
    try {
      apps.value = await getUserAvailableApps()
      error.value = null
    } catch (err) {
      error.value =
        err instanceof Error
          ? err.message
          : 'An error occurred while fetching apps'
    } finally {
      isLoading.value = false
    }
  }

  return {
    apps,
    isLoading,
    error,
    userPinnedApps,
    updateUserHasPinnedAppStatus,
    userHasPinnedApp,
    fetchApps,
  }
})
